import { ActionIcon, Button, Group, TextInput } from "@mantine/core";
import { IconLayoutList, IconList, IconPlus, IconSearch } from "@tabler/icons-react";
import { FormattedMessage, useIntl } from "react-intl";
import { useNavigate } from "@tanstack/react-router";
import { memo, type FC } from "react";
import { captureEvent } from "../../../../utils/posthog";
import { Event } from "../../../../constants/events";
import { usePathAccountName } from "../../../../hooks/router";

interface TilesetListControlsProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  isCondensedView: boolean;
  toggleView: () => void;
}

export const TilesetListControls: FC<TilesetListControlsProps> = memo(({
  searchQuery,
  setSearchQuery,
  isCondensedView,
  toggleView,
}) => {
  const intl = useIntl();
  const accountName = usePathAccountName();
  const navigate = useNavigate();

  const handleNavigateToNew = () => {
    void navigate({
      to: "/$accountName/new-tileset",
      params: { accountName },
    });
  };

  return (
    <Group justify="space-between" align="center" mb="md">
      <Group gap="xs">
        <ActionIcon
          variant="default"
          size="lg"
          aria-label={intl.formatMessage({
            defaultMessage: "Toggle view",
            id: "button.toggleView",
          })}
          onClick={toggleView}
        >
          {isCondensedView
            ? <IconLayoutList size={18} />
            : <IconList size={18} /> }
        </ActionIcon>

        <TextInput
          placeholder={intl.formatMessage({
            defaultMessage: "Search tilesets...",
            id: "placeholder.searchTilesets",
          })}
          value={searchQuery}
          onChange={(e) => {
            captureEvent(Event.TilesetSearchTilesets);
            setSearchQuery(e.currentTarget.value);
          }}
          leftSection={<IconSearch size={16} />}
          w="320px"
        />
      </Group>

      <Button
        leftSection={<IconPlus size={16} />}
        onClick={handleNavigateToNew}
        variant="primary"
      >
        <FormattedMessage defaultMessage="New Tileset" id="button.newTileset" />
      </Button>
    </Group>
  );
});
